import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import IconCarbonCheckmarkOutline from '@/shared/icons/IconCarbonCheckmarkOutline'
import { Alert } from 'baseui/icon'
import {
  selectContactConfig,
  selectCurrentOrFirstContract,
  selectIdentityContactSubscriptionData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { updateClientData } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import { selectAuthData, selectEnergyAuthCommonData } from '@/containers/Login/AuthSelectors'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'
import useFormStatus from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useFormStatus'
import useModal from '@/shared/hooks/v2/useModal'

const ErrorEnhancer = () => <Alert size={24} color='red' />
const FilledEnhancer = () => <IconCarbonCheckmarkOutline size={24} color='green' />

const useIdentity = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { country } = useSelector(selectAuthData)
  const { formIsLoaded, zohoIsInValid, isEditable } = useFormStatus()
  // @ts-ignore
  const customerConfig = modulesConfig[country]?.customer ?? {}
  const { isOpen, openModal, closeModal } = useModal({
    selector: selectContactConfig,
    // @ts-ignore
    actionCreator: data => updateClientData({ data, name: 'config' }),
    modalKey: 'identityModal',
  })
  const { documentTypeOptions: documentTypeOptionsRaw } = useSelector(selectEnergyAuthCommonData) ?? {}
  const documentTypeOptions = Object.keys(documentTypeOptionsRaw ?? {})
  const contract = useSelector(selectCurrentOrFirstContract)
  // @ts-ignore
  const identityDocumentMandatoryOperations: string[] =
    contract?.config?.providerConfiguration?.identityDocumentMandatoryOperations ?? []
  // @ts-ignore
  const prestationType: string = contract?.characteristics?.prestationType ?? ''
  const isMandatory = identityDocumentMandatoryOperations.includes(prestationType)

  const {
    documentType,
    documentNumber,
    expirationDate = '',
    createdDate = '',
    issuingEntity,
    issuingCity,
  } = useSelector(selectIdentityContactSubscriptionData) ?? {}

  const updateIdentity = (data: object) => {
    // @ts-ignore
    dispatch(updateClientData({ data, name: 'identity' }))
  }

  const isFilled =
    Boolean(documentNumber) &&
    Boolean(expirationDate) &&
    Boolean(createdDate) &&
    Boolean(issuingEntity) &&
    Boolean(issuingCity)
  const hasError = isMandatory && !isFilled

  const getButtonEndEnhancer = () => {
    if (hasError) return ErrorEnhancer
    if (isFilled) return FilledEnhancer
    return undefined
  }
  const buttonEndEnhancer = getButtonEndEnhancer()

  return {
    t,
    formIsLoaded,
    zohoIsInValid,
    isEditable,
    hidden: !customerConfig.identity,
    isMandatory,
    isFilled,
    hasError,
    buttonEndEnhancer,
    isOpen,
    openModal,
    closeModal,
    documentType,
    documentNumber,
    expirationDate: expirationDate ? new Date(expirationDate) : '',
    createdDate: createdDate ? new Date(createdDate) : '',
    issuingEntity,
    issuingCity,
    documentTypeOptions,
    updateIdentity,
  }
}

export default useIdentity
